import React from 'react'

import Paper from 'app/components/base/Paper'
import SignUpPersonalFeature from 'app/features/Auth/SignUpPersonalFeature'
import GoogleReCaptchaV3Provider from 'app/providers/GoogleRecaptchaV3Provider'

import AuthContainer from '~/components/layouts/AuthContainer'

const SignUpPersonalView: RFC = () => {
  return (
    <AuthContainer>
      <Paper>
        <GoogleReCaptchaV3Provider>
          <SignUpPersonalFeature />
        </GoogleReCaptchaV3Provider>
      </Paper>
    </AuthContainer>
  )
}

export default SignUpPersonalView
